// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NC-5F","content":"styles_content__1piqA","tableWrap":"styles_tableWrap__mt-dH"};